import { Dispatch } from 'redux';
import {
  createSubmissionGroup,
  deleteSubmissionGroup,
  getAllNotDeletedGroups,
  getAllSubmissionGroups,
  updateSubmissionGroup,
} from '@services/submissionGroupService';
import { submissionGroupActionTypes } from './actionTypes/submissionGroups';
import { loading } from './commonActions';
import {
  CreateSubmissionGroupRequestInterface,
  SubmissionGroupEntityInterface,
  SubmissionGroupQueryInterface,
  UpdateSubmissionGroupRequestInterface,
} from '@types';
import { SubmissionGroupSortEnum } from '@enums';
import { setNotification } from '@actions/appActions';

export const setSubmissionGroups = (submissionGroups: SubmissionGroupEntityInterface[]) => {
  return {
    type: submissionGroupActionTypes.SET_SUBMISSION_GROUPS,
    payload: submissionGroups,
  };
};

export const makeSubmissionGroups =
  (query?: SubmissionGroupQueryInterface) => async (dispatch: Dispatch) => {
    try {
      if (query) {
        query.order = [SubmissionGroupSortEnum.submissionGroupCreatedAt_ASC];
      } else {
        query = { order: [SubmissionGroupSortEnum.submissionGroupCreatedAt_ASC] };
      }
      const { items } = await getAllSubmissionGroups(query);

      dispatch(setSubmissionGroups(items));
    } catch (e) {
      dispatch(setSubmissionGroups([]));
    }
  };

export const makeCreateSubmissionGroup =
  (data: CreateSubmissionGroupRequestInterface) => async (dispatch) => {
    const instanceName = 'create_group';
    try {
      dispatch(loading(true, instanceName));
      await createSubmissionGroup(data);
      dispatch(makeSubmissionGroups());
    } catch (err) {
      dispatch(loading(false, instanceName));
      dispatch(setNotification({ textKey: 'group_name_exist', variant: 'error' }));
    } finally {
      dispatch(loading(false, instanceName));
    }
  };

export const makeUpdateSubmissionGroup =
  (id: string, data: UpdateSubmissionGroupRequestInterface) => async (dispatch) => {
    const instanceName = 'update_group';
    try {
      dispatch(loading(true, instanceName));
      await updateSubmissionGroup(id, data);
      dispatch(makeSubmissionGroups());
    } catch (err) {
      dispatch(loading(false, instanceName));
      dispatch(setNotification({ textKey: 'group_name_exist', variant: 'error' }));
    } finally {
      dispatch(loading(false, instanceName));
    }
  };

export const makeDeleteSubmissionGroup = (id: string) => async (dispatch) => {
  const instanceName = 'delete_group';
  try {
    dispatch(loading(true, instanceName));
    await deleteSubmissionGroup(id);
    dispatch(makeSubmissionGroups());
  } catch (err) {
    dispatch(loading(false, instanceName));
  } finally {
    dispatch(loading(false, instanceName));
  }
};

export const setAllSubmissionGroups = (submissionGroups: SubmissionGroupEntityInterface[]) => {
  return {
    type: submissionGroupActionTypes.SET_ALL_SUBMISSION_GROUPS,
    payload: submissionGroups,
  };
};

export const makeAllSubmissionGroups = async (dispatch) => {
  try {
    const { items } = await getAllNotDeletedGroups();
    dispatch(setAllSubmissionGroups(items));
  } catch (err) {
    dispatch(setNotification({ textKey: 'error', variant: 'error' }));
  }
};
